import { ListPageHeader } from '@/components/common/ListPageHeader'
import { useRegions } from '@/features/region/hooks'
import { RegionCard } from './components/RegionCard'

export function RegionsAdminPage() {
  const { data: regions, isLoading } = useRegions()

  return (
    <div className="flex flex-col w-full">
      <ListPageHeader
        title="Regiony - handlowcy"
        subtitle={
          <>
            Przypisanie handlowców do regionów (1 region na handlowca). Definicję regionów edytujesz w{' '}
            <a href="/settings/dictionaries" className="text-sky-700 hover:underline">Słownikach → Regiony</a>.
          </>
        }
      />
      <div className="p-4 flex flex-col gap-4 max-w-3xl">
        {isLoading && <div className="text-xs text-slate-500">Ładowanie…</div>}
        {regions && regions.length === 0 && (
          <div className="text-xs text-slate-500">
            Brak regionów. Dodaj je w Słownikach → Regiony.
          </div>
        )}
        {regions?.map((r) => (
          <RegionCard key={r.code} code={r.code} labelPl={r.labelPl} />
        ))}
      </div>
    </div>
  )
}
